import type {NextPageWithLayout} from './_app'
import {Layout} from "@components/layouts/layout";
import {ReactElement} from "react";
import Link from "@components/elements/DocumentLink";

// export interface IIndexPageProps {
export interface IAboutPageProps {
}

// @ts-ignore
const Page: NextPageWithLayout = () => {
    // About us page with text and images interpolated, created with tailwindcss
    return (<>
        <div className="bg-white dark:bg-gray-800">
            <div className="max-w-3xl mx-auto py-16 px-4">
                <div className="max-w-5xl mx-auto text-center flex flex-col gap-8">
                    <h1 className="page-title text-4xl font-extrabold text-gray-900 dark:text-gray-100 sm:text-5xl sm:tracking-tight lg:text-6xl">
                        About us
                    </h1>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        We are a team of engineers and indie makers creating products to help other indie makers.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        The wordpress marketplace has huge potential, but is very inefficient.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        When users search for plugins, they are presented with sponsored articles for plugins
                        instead of
                        going through a data-driven process to find the best plugins for their needs. We consider
                        this
                        unacceptable.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400 font-bold">
                        We are here to change that...
                    </p>
                    <h2 className="text-2xl font-extrabold text-gray-900 dark:text-gray-100 sm:text-3xl sm:tracking-tight lg:text-4xl">
                        Our mission
                    </h2>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        We provide a variety to help WordPress users, indie makers and investors explore the
                        wordpress
                        ecosystem.
                    </p>
                    <h3 className="text-lg font-extrabold text-gray-900 dark:text-gray-100 sm:text-xl sm:tracking-tight lg:text-2xl">
                        Wordpress Developers
                    </h3>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        We help you find the best plugins for your needs with our
                        <Link
                            href="/plugins"
                            className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                        >
                            Wordpress Plugin Finder©
                        </Link>, which aggregates data from the wordpress marketplace
                        and
                        provides you with a data-driven process to find the best plugins for your needs.
                    </p>
                    <h3 className="text-lg font-extrabold text-gray-900 dark:text-gray-100 sm:text-xl sm:tracking-tight lg:text-2xl">
                        Plugin Developers
                    </h3>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        We help indie makers find opportunities within the wordpress ecosystem
                        with our
                        <Link
                            href="/plugins"
                            className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                        >
                            Niche Finder Tool©
                        </Link> and
                        <Link
                            href="/plugins"
                            className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                        >
                            Wordpress Marketplace Explorer©
                        </Link>.
                    </p>
                    <h3 className="text-lg font-extrabold text-gray-900 dark:text-gray-100 sm:text-xl sm:tracking-tight lg:text-2xl">
                        Investors
                    </h3>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        We help you find the best wordpress plugins to invest in or acquire with our
                        <Link
                            href="/plugins"
                            className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                        >
                            Wordpress Investment Explorer©
                        </Link> and our
                        <Link
                            href="/plugins"
                            className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                        >
                            Wordpress Acquisition Explorer©
                        </Link>.
                    </p>
                    <h1 className="page-title text-4xl font-extrabold text-gray-900 dark:text-gray-100 sm:text-5xl sm:tracking-tight lg:text-6xl">
                        Our vision
                    </h1>
                    <h2 className="text-2xl font-extrabold text-gray-900 dark:text-gray-100 sm:text-3xl sm:tracking-tight lg:text-4xl">
                        Have you heard about information asymmetry?
                    </h2>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        Information asymmetry is a situation where one party has more information than the other
                        party
                        during a transaction or negotiation.
                        Information asymmetry creates an imbalance of power in transactions, which can sometimes
                        cause
                        the transactions to be inefficient or unfair, producing a loss of value for the parties
                        involved
                        in the best case, and a market failure in the worst case.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        The wordpress marketplace is a perfect example of a market with information asymmetry.
                        Wordpress
                        developers don&#39;t have reliable sources of information about the plugins available for
                        their
                        specific needs, instead, they have to rely on sponsored articles and word of mouth to make
                        their decisions.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        If wordpress developers had access to reliable sources of information about the plugins
                        available for their specific needs, they would be able to make better decisions, which would
                        lead to more transactions, more value creation and a more efficient market.
                    </p>
                    <p className="text-xl text-gray-500 dark:text-gray-400">
                        This is the problem we are trying to solve, beyond the wordpress ecosystem.
                    </p>
                </div>
            </div>
        </div>
    </>)
}

Page.getLayout = function getLayout(page: ReactElement) {
    const baseUrl = String(process.env.NEXT_PUBLIC_WEBSITE_URL || "");
    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    const canonicalUrl = normalizedBaseUrl ? `${normalizedBaseUrl}/about` : "/about";
    const imageUrl = normalizedBaseUrl ? `${normalizedBaseUrl}/catspyjamas.jpg` : "/catspyjamas.jpg";

    return (<Layout
        title={"About us"}
        description={"We are a team of engineers and indie makers creating products to help other indie makers."}
        url={canonicalUrl}
        image={imageUrl}
    >
        {page}
    </Layout>)
}

export default Page
